module.exports = __webpack_public_path__ + "img/biaoqian.2916c64f.svg";